// Menu Functions Consolidated
$(document).ready(function () {
  $(".custom-scrollbar, .custom-scrollbar-2").hide();

  $("#mobileMenuButton").click(function () {
    $("#mobileNav").slideToggle();
  });

  $("#mobileNav a").click(function () {
    $("#mobileNav").slideToggle();
  });

  $(".heading-24").click(function () {
    window.scrollTo(0, 0);
  });

  var header = $("#shopify-section-header");
  var headerOffset = header.offset().top;

  $(window).on("scroll", function () {
    if ($(window).scrollTop() > headerOffset) {
      //header.addClass("sticky");
    } else {
      //header.removeClass("sticky");
    }
  });

  $(window).on(
    "resize",
    debounce(function () {
      //location.reload();
    }, 250)
  );

  function debounce(func, wait) {
    var timeout;
    return function () {
      clearTimeout(timeout);
      timeout = setTimeout(func, wait);
    };
  }

  $(".burger-menu1A").click(function () {
    if ($(".main-content-container1").hasClass("menu-open")) {
      $(".main-content-container1").removeClass("menu-open");
      $(".mobile-menu1B").css("left", "-250px");
      $("body").removeClass("no-scroll"); // Re-enable scrolling
    } else {
      $(".main-content-container1").addClass("menu-open");
      $(".mobile-menu1B").css("left", "0");
      $("body").addClass("no-scroll"); // Disable scrolling
    }
  });

  function toggleMenu(buttonClass, panelId) {
    $(buttonClass).click(function () {
      var $panelCollapse = $(panelId);
      var $icon = $(this).find(".lin");

      // Close any open panels
      $("#pushy-menu .panel-collapse.in")
        .not($panelCollapse)
        .slideUp()
        .removeClass("in");
      $("#pushy-menu .lin-arrow-up")
        .not($icon)
        .removeClass("lin-arrow-up")
        .addClass("lin-arrow-down");

      // Toggle the clicked panel
      if ($panelCollapse.is(":visible")) {
        $panelCollapse.slideUp().removeClass("in");
        $icon.removeClass("lin-arrow-up").addClass("lin-arrow-down");
      } else {
        $panelCollapse.slideDown().addClass("in");
        $icon.removeClass("lin-arrow-down").addClass("lin-arrow-up");
      }
    });

    $("#pushy-menu .lin.lin-arrow-down").on("click", function () {
      $(this).toggleClass("lin-arrow-down lin-arrow-up");
    });
  }

  toggleMenu(
    "#pushy-menu .second_level_drop_link.products_2Button",
    "#pushy-menu #products_2"
  );
  toggleMenu(
    "#pushy-menu .second_level_drop_link.services_2Button",
    "#pushy-menu #services_2"
  );
  toggleMenu(
    "#pushy-menu .second_level_drop_link.support_4Button",
    "#pushy-menu #support_4"
  );

  // Show dialog and disable vertical scroll
  $("#nav-search-dialog-button").on("click", function () {
    $("#nav-search-dialog").show();
    $("#nav-search-dialog").attr("style", "display: block !important;");
    $("body").css("overflow", "hidden");
  });

  // Hide dialog and enable vertical scroll
  $("#nav-search-dialog-exit").on("click", function () {
    $("#nav-search-dialog").hide();
    $("#nav-search-dialog").attr("style", "display: none !important;");
    //$("body").css("overflow", "auto");
    $("body").css("overflow-x", "clip");
    $("body").css("overflow-y", "visible");
  });

  $(".dropdown-products, .dropdown-support, .dropdown-services").hover(
    function () {
      $(this).closest(".dropdown").find(".dropdown-menu").show();
    },
    function () {
      $(this).closest(".dropdown").find(".dropdown-menu").hide();
    }
  );

  $(".dropdown-menu").hover(
    function () {
      $(this).show();
    },
    function () {
      $(this).hide();
    }
  );

  $(".lin.lin-arrow-down").on("click", function () {
    $(this).toggleClass("lin-arrow-down lin-arrow-up");
  });

  $("#closeMobileMenu, .no-scroll").on("click", function () {
    $("#pushy-menu-btn").trigger("click");
  });
});

// Reviews Slider
$(document).ready(function () {
  const $templateSlides = $("#mySliderX_allSlides .mySliderX_slide");
  const total = $templateSlides.length;
  const $track = $("#mySliderX_track");
  const isMobile = () => window.innerWidth < 768;
  let index = 0;

  function renderSlides() {
    $track.empty();

    const i1 = index % total;
    const i2 = (index + 1) % total;
    const i3 = (index + 2) % total;

    const $first = $templateSlides.eq(i1).clone().addClass("left-slide");
    $track.append($first);

    if (!isMobile()) {
      const $second = $templateSlides.eq(i2).clone();
      const $third = $templateSlides.eq(i3).clone();
      $track.append($second, $third);
    }

    requestAnimationFrame(() => {
      $track.find(".mySliderX_slide").each(function () {
        $(this).addClass("animated-in");
      });
    });
  }

  $("#mySliderX_nextBtn, #mySliderX_nextBtn2").on("click", function () {
    index = (index + 1) % total;
    renderSlides();
  });

  $("#mySliderX_prevBtn, #mySliderX_prevBtn2").on("click", function () {
    index = (index - 1 + total) % total;
    renderSlides();
  });

  $(window).on("resize", renderSlides);

  renderSlides();
});

// Toggle Content
$(document).ready(function () {
  $("#btnScanner").on("click", function () {
    $("#scannerDiv").removeClass("d-none");
    $("#phoneDiv").addClass("d-none");
    $(this).removeClass("btn-outline-light").addClass("btn-light");
    $("#btnPhone").removeClass("btn-light").addClass("btn-outline-light");
  });

  $("#btnPhone").on("click", function () {
    $("#phoneDiv").removeClass("d-none");
    $("#scannerDiv").addClass("d-none");
    $(this).removeClass("btn-outline-light").addClass("btn-light");
    $("#btnScanner").removeClass("btn-light").addClass("btn-outline-light");
  });
});

// CTA to Device Comparo
$(".startScanningNowButton-not-in-use").on("click", function (e) {
  e.preventDefault(); // optional: prevents default link behavior
  $("html, body").animate(
    {
      scrollTop: $("#compareProductsWrapper").offset().top,
    },
    600
  ); // 600ms for smooth animation
});

// Tooltip
$(document).ready(function () {
  const jsonData = {
    "autoReLink-icon":
      "Auto-Relink automatically re-scans the vehicle at regular intervals, ensuring readiness monitors and key parameters are updated for SMOG testing and emissions compliance.",
    "codePriority-icon":
      "Code Priority refers to identifying the main fault code responsible for triggering your dashboard light. In many cases, resolving the primary fault code can also address related secondary codes that appear afterward.",
    "driveCycleProcedures-icon":
      "Drive Cycle Procedures refers to the ability of guiding you through each specific driving step to reset monitors for SMOG testing with real time instructions.",
    "bidirectionalSystemTest-icon":
      "Bidirectional System Tests let you control vehicle systems to identify issues. Common tests include actuator tests, EVAP system tests, injector balance tests, and solenoid tests.",
    "specialFunctionsRoutinesCalibrations-icon":
      "Special Functions refer to special reset features like SAS, DPF regen, EVAP VSV check, and more.",
    "all10ObdModes-icon":
      "<strong>Mode 01</strong> - I/M Readiness Status/Live Data Mode (PIDs)<br><strong>Mode 02</strong> - Freeze Frame Data<br><strong>Mode 03</strong> - Emission Related DTCs<br><strong>Mode 04</strong> - Erase DTCs<br><strong>Mode 05</strong> - Request O2 test results<br><strong>Mode 06</strong> - I/M Monitor Tests/Monitoring test results and parameters<br><strong>Mode 07</strong> - Two Trip Pending Diagnostic Trouble Code<br><strong>Mode 08</strong> - Request control of Onboard Component<br><strong>Mode 09</strong> - Request vehicle info<br><strong>Mode 10</strong> or <strong>Mode 0a</strong> - Permanent DTC",
    "all8ObdModes-icon":
      "<strong>Mode 01</strong> - I/M Readiness Status/Live Data Mode (PIDs)<br><strong>Mode 02</strong> - Freeze Frame Data<br><strong>Mode 03</strong> - Emission Related DTCs<br><strong>Mode 04</strong> - Erase DTCs<br><strong>Mode 05</strong> - Request O2 test results<br><strong>Mode 07</strong> - Two Trip Pending Diagnostic Trouble Code<br><strong>Mode 09</strong> - Request vehicle info<br><strong>Mode 10</strong> or <strong>Mode 0a</strong> - Permanent DTC",
    "secureGatewayForFCAvehicles-icon":
      "Secure Gateway access enables select scanners to unlock FCA vehicles' secure gateway by connecting through an AutoAuth account.",
    "batteryTooltip-unused": "Long-lasting battery life for extended usage.",
  };

  let activeTooltip = null;

  // Event delegation for dynamically added elements
  $("body").on("click", ".tooltipForComparo-trigger", function (e) {
    e.stopPropagation();

    // Close any existing tooltip
    if (activeTooltip) {
      activeTooltip.remove();
      activeTooltip = null;
    }

    const $trigger = $(this);
    const uniqueClass = $trigger
      .attr("class")
      .split(" ")
      .find((cls) => jsonData[cls]);

    const tooltipText = jsonData[uniqueClass] || "Tooltip not available.";

    // Create the tooltip dynamically
    const $tooltip = $('<div class="tooltipForComparo"></div>').html(
      tooltipText
    );

    // Append tooltip to the body
    $("body").append($tooltip);

    // Position the tooltip
    const rect = $trigger[0].getBoundingClientRect();
    const left = rect.left + window.scrollX;
    const top = rect.top + window.scrollY - $tooltip.outerHeight() - 10;

    $tooltip.css({
      left: `${left}px`,
      top: `${top}px`,
      display: "block",
    });

    activeTooltip = $tooltip;
  });

  // Close tooltip on outside click
  $(document).on("click", function () {
    if (activeTooltip) {
      activeTooltip.remove();
      activeTooltip = null;
    }
  });

  // Close tooltip on scroll
  $("#productComparo").on("scroll", function () {
    if (activeTooltip) {
      activeTooltip.remove();
      activeTooltip = null;
    }
  });

  // Handle tooltips inside Bootstrap modals
  $(document).on("shown.bs.modal", function (e) {
    const $modal = $(e.target);

    $modal.on("click", ".tooltipForComparo-trigger", function (e) {
      e.stopPropagation();

      // Close any existing tooltip
      if (activeTooltip) {
        activeTooltip.remove();
        activeTooltip = null;
      }

      const $trigger = $(this);
      const uniqueClass = $trigger
        .attr("class")
        .split(" ")
        .find((cls) => jsonData[cls]);

      const tooltipText = jsonData[uniqueClass] || "Tooltip not available.";

      // Create the tooltip dynamically
      const $tooltip = $('<div class="tooltipForComparo"></div>').html(
        tooltipText
      );

      // Append tooltip to the modal
      $modal.append($tooltip);

      // Position the tooltip
      const rect = $trigger[0].getBoundingClientRect();
      const left = rect.left;
      const top = rect.top - $tooltip.outerHeight() - 10;

      $tooltip.css({
        left: `${left}px`,
        top: `${top}px`,
        display: "block",
      });

      activeTooltip = $tooltip;
    });

    // Close tooltip on scroll inside the modal
    $modal.on("scroll", function () {
      if (activeTooltip) {
        activeTooltip.remove();
        activeTooltip = null;
      }
    });
  });
});

$(document).ready(function () {
  function setupMarquee() {
    const $list = $(".benefits-list");

    if (window.innerWidth <= 768 && !$list.hasClass("marquee-setup")) {
      const $originalItems = $list.children().clone().addClass("mobileVersion");
      $list.append($originalItems); // append cloned items with class
      $list.addClass("marquee-setup");
    }
  }

  setupMarquee(); // on page load

  $(window).on("resize", function () {
    setupMarquee(); // on window resize
  });

  // Initially hide all rows
  /*$(".advancedDiagnosticsRow, .essentialDiagnosticsRow").hide();

  // Toggle Essential Diagnostics
  $(".essentialDiagnosticsHeader").on("click", function () {
    $(".essentialDiagnosticsRow").toggle();
    let $icon = $(this).find(".toggle-icon");
    $icon.text($icon.text() === "+" ? "−" : "+");
  });

  // Toggle Advanced Diagnostics
  $(".advancedDiagnosticsHeader").on("click", function () {
    $(".advancedDiagnosticsRow").toggle();
    let $icon = $(this).find(".toggle-icon");
    $icon.text($icon.text() === "+" ? "−" : "+");
  });

  const gadgetComparisonPanel = document.getElementById("productComparo");
  const dynamicScrollIndicator = document.querySelector(
    ".custom-scrollbar-thumb-2"
  );

  function adjustScrollIndicator() {
    const totalScrollableWidth =
      gadgetComparisonPanel.scrollWidth - gadgetComparisonPanel.clientWidth;
    const currentScrollPosition = gadgetComparisonPanel.scrollLeft;
    const indicatorWidth = (currentScrollPosition / totalScrollableWidth) * 100;
    dynamicScrollIndicator.style.width = `${Math.max(indicatorWidth, 50)}%`;
  }

  adjustScrollIndicator();

  gadgetComparisonPanel.addEventListener("scroll", adjustScrollIndicator);*/

  $("#scannerTables").on("scroll", function () {
    const $this = $(this);
    if ($this.scrollLeft() > 0) {
      $(".scrollToRight").hide();
    } else {
      $(".scrollToRight").show();
    }
  });

  // // Wait until Tidio is fully loaded
  // document.addEventListener("tidioChat-ready", function () {
  //   $("#openTidioChat").on("click", function () {
  //     // Open the Tidio chat widget
  //     tidioChatApi.open();
  //   });
  // });

  
  $("#openTidioChat").on("click", function () {    
    toggleInnovaChat();    
  });

});

// Pulse Animations - Showcase Callout Animations
let hasPlayedOnce = false;

// Fully hide texts initially
/*$(
  ".showcaseText1, .showcaseText2, .showcaseText3, .showcaseText4, .showcaseText5, .showcaseText6"
).css({
  opacity: 0,
  visibility: "hidden",
});*/

// Prepare arrow styles
for (let i = 1; i <= 6; i++) {
  $(`.showcaseArrow${i}`).css({
    opacity: 1,
    overflow: "hidden",
    width: "0",
    direction: i % 2 === 1 ? "ltr" : "rtl",
    display: "block",
    visibility: "visible",
  });
}

function startShowcaseSequence() {
  hasPlayedOnce = true;

  for (let i = 1; i <= 6; i++) {
    setTimeout(() => {
      $(`.showcaseText${i}`).fadeTo(200, 1).css("opacity", 1);
    }, (i - 1) * 150);
  }

  for (let i = 1; i <= 6; i++) {
    setTimeout(() => {
      $(`.showcaseArrow${i}`)
        .animate({ width: "100%" }, 200)
        .css("width", "100%");
    }, 800 + (i - 1) * 300);
  }

  observer.disconnect();
}

// Observe entry, delay start by 500ms
const observer = new IntersectionObserver(
  (entries) => {
    const entry = entries[0];
    if (entry.isIntersecting && !hasPlayedOnce) {
      setTimeout(startShowcaseSequence, 500);
    }
  },
  { threshold: 0.2 }
);

observer.observe(document.querySelector("#productShowcase1"));

/* Pulse Animations Text */
$(document).ready(function () {
  if (window.innerWidth <= 768) {
    setTimeout(function () {
      $(".pulseImage1").click();
    }, 2000);
  }

  let lastClicked = null;
  const messages = [
    "<p>Engine Misfire Detected<br><span>May cause rough running or loss of power</span></p>",
    "<p>Brake Issue Detected<br><span>C0035 - may indicate a damaged sensor wiring</span></p>",
    "<p>Low Battery & Oil Life<br><span>Know the remaining battery, brake pad, and oil life</span></p>",
    "<p>Emissions Issue<br><span>Does not pass state’s SMOG standards</span></p>",
    "<p>Unlimited Reports<br><span>Enjoy unlimited scans and report sharing</span></p>",
    "<p>Projected Car Repairs<br><span>Know the potential expensive breakdowns that may come with your used car</span></p>",
  ];

  $(".pulseImage").each(function (index) {
    $(this).on("click", function () {
      if (lastClicked && lastClicked[0] !== this) {
        lastClicked.find(".clickedImageButton").fadeOut(200);
        lastClicked.find(".staticImageButton").fadeIn(200);
      }

      $(this).find(".staticImageButton").fadeOut(200);
      $(this).find(".clickedImageButton").fadeIn(200);

      $("#pulseText").html(messages[index]);
      lastClicked = $(this);
    });
  });
});

// Scroll to div
$('a[href="#content2"]').on("click", function (e) {
  e.preventDefault(); // prevent URL change
  $("#content2")[0].scrollIntoView({ behavior: "smooth" });
});
$('a[href="#gettingStarted3"]').on("click", function (e) {
  e.preventDefault(); // prevent URL change
  $("#gettingStarted3")[0].scrollIntoView({ behavior: "smooth" });
});
$(".pageTitle1").on("click", function (e) {
  setTimeout(function () {
    window.scrollTo(0, 0);
  }, 0);
});
$("#stickySubHeaderNav .subHeaderNavWrapper .row div.col-md-7 ul li a").on(
  "click",
  function (e) {
    // Check if this link has an anchor hash
    if (this.hash !== "") {
      e.preventDefault(); // prevent instant jump

      var target = $(this.hash); // find the element with that id
      if (target.length) {
        $("html, body").animate(
          {
            //scrollTop: target.offset().top,
            scrollTop: target.offset().top - 100 // stop 100px before the target
          },
          500 // scroll speed in ms
        );
      }
    }
  }
);

// Custom Scrollbar
const gadgetComparisonPanel = document.getElementById("productComparo");
const dynamicScrollIndicator = document.querySelector(
  ".custom-scrollbar-thumb"
);

function adjustScrollIndicator() {
  const totalScrollableWidth =
    gadgetComparisonPanel.scrollWidth - gadgetComparisonPanel.clientWidth;
  const currentScrollPosition = gadgetComparisonPanel.scrollLeft;
  const indicatorWidth = (currentScrollPosition / totalScrollableWidth) * 100;
  dynamicScrollIndicator.style.width = `${Math.max(indicatorWidth, 50)}%`;
}

adjustScrollIndicator();

gadgetComparisonPanel.addEventListener("scroll", adjustScrollIndicator);

$(document).ready(function () {
  // Reset scroll on load
  setTimeout(function () {
    window.scrollTo(0, 0);
  }, 0);

  // Reset scroll on refresh
  $(window).on("beforeunload", function () {
    window.scrollTo(0, 0);
  });
});
